'use client';

import { ReactNode } from 'react';
// @ts-ignore
import { ProgressProvider } from '@bprogress/next/app';
import { useTheme } from '@mui/material';

export const TopLoader = ({ children }: { children?: ReactNode }) => {
    const theme = useTheme();
    const primaryColor = theme.colors.other.background.preloader;

    return (
        <ProgressProvider color={primaryColor} options={{ showSpinner: false }} shallowRouting>
            {children}
        </ProgressProvider>
    );
};
